import React, { useRef, useState } from "react";
import { FormContext } from "./formContext";
import { defaultButtonText, defaultHeaderTitleText } from "./constants";
import { emptySetterFunction } from "@utils/helpers/emptyFunction";

export const FormContextProvider = ({children}) => {
  const onSubmitRef = useRef(emptySetterFunction);
  const getOnSubmit = () => onSubmitRef.current;
  const setOnSubmit = (value) => {
    onSubmitRef.current = value();
  };

  const [buttonText, setButtonText] = useState(() => defaultButtonText);
  const [hidden, setHidden] = useState(() => false);
  
  const [title, setTitle] = useState(() => defaultHeaderTitleText);

  return (
    <FormContext.Provider value={{
      button: {
        getOnSubmit,
        setOnSubmit,
        buttonText,
        setButtonText,
        hidden,
        setHidden,
      },
      header: {
        title,
        setTitle,
      }
    }}>
      {children}
    </FormContext.Provider>
  )
};